export const menuTabs = {
  home: 'Home',
  repairs: 'Repairs',
  parts: 'Parts',
  VINScanner: 'VIN Scanner',
  profile: 'Profile',
  notifications: 'Notifications',
  help: 'Help',
  logOut: 'LogOut',
} as const;
